import * as React from "react";
export default function LinkReport(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={33}
      height={33}
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={33} height={33} rx={9.9} fill="#27272A" />
      <path
        d="M14.025 20.625H12.375C11.281 20.625 10.2318 20.1904 9.45818 19.4168C8.6846 18.6432 8.25 17.594 8.25 16.5C8.25 15.406 8.6846 14.3568 9.45818 13.5832C10.2318 12.8096 11.281 12.375 12.375 12.375H14.025"
        stroke="url(#paint0_linear_95_131)"
        strokeWidth={2.475}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9751 12.375H20.6251C21.7191 12.375 22.7683 12.8096 23.5419 13.5832C24.3155 14.3568 24.7501 15.406 24.7501 16.5C24.7501 17.594 24.3155 18.6432 23.5419 19.4168C22.7683 20.1904 21.7191 20.625 20.6251 20.625H18.9751"
        stroke="url(#paint1_linear_95_131)"
        strokeWidth={2.475}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.2002 16.5H19.8002"
        stroke="url(#paint2_linear_95_131)"
        strokeWidth={2.475}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_95_131"
          x1={11.1375}
          y1={12.375}
          x2={11.1375}
          y2={20.625}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset={1} stopColor="white" stopOpacity={0.65} />
        </linearGradient>
        <linearGradient
          id="paint1_linear_95_131"
          x1={21.8626}
          y1={12.375}
          x2={21.8626}
          y2={20.625}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset={1} stopColor="white" stopOpacity={0.65} />
        </linearGradient>
        <linearGradient
          id="paint2_linear_95_131"
          x1={16.5002}
          y1={16.5}
          x2={16.5002}
          y2={17.5}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset={1} stopColor="white" stopOpacity={0.65} />
        </linearGradient>
      </defs>
    </svg>
  );
}
